import * as React from "react";
import { observer } from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { message } from "antd";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";
import { ProjectDocumentsTable } from "Components/General/AddFilesInput/ProjectDocumentsTable";
import { ProjectFilesSearch } from "./ProjectFilesSearch";
import { taskAttachmentsStore } from "../Stores/TaskAttachmentsStore";
import { taskSubmitStore } from "../Stores/TaskSubmitStore";
import { taskModalStore } from "../Stores";

interface AttachProjectFilesProps extends WithTranslation, ModalComponentProps {
  addFile: (v: API_TaskRequestData) => Promise<void>;
}

type attachSection = "NAV" | "SEARCH";

interface AttachProjectFilesState {
  renderSection: attachSection; // enums that represent showing of certain section
}

export const AttachProjectFiles = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<AttachProjectFilesProps, AttachProjectFilesState> {
      constructor(props: AttachProjectFilesProps) {
        super(props);

        this.state = {
          renderSection: "NAV",
        };
      }

      toggleSection = () => {
        const renderSection = this.state.renderSection === "NAV" ? "SEARCH" : "NAV";
        this.setState({ renderSection });
      };

      handleAddAttachments = async (data) => {
        if (!data.length) {
          message.error(this.props.t("No files selected"));
        } else {
          data.forEach((file) => {
            taskAttachmentsStore.addProjectFile(file);
          });
          /**
           * https://pmgredesign.atlassian.net/browse/DEV-5223
           * Creating task from Docs module
           */
          if (!taskModalStore.isVisible) {
            /**
             * https://pmgredesign.atlassian.net/browse/DEV-5125
             * Saving files does not depend on saving the task in general
             * (only in edit mode)
             */
            await this.props.addFile(taskSubmitStore.data);
          }
          this.props.hideModal();
        }
      };

      render() {
        if (this.state.renderSection === "NAV") {
          return (
            <ProjectDocumentsTable
              handleAddAttachments={this.handleAddAttachments}
              onShowSearch={this.toggleSection}
              onExit={this.props.hideModal}
              minimumAccessLevel="READONLY"
              // initialValue={taskDataStore.fileList}
            />
          );
        } else if (this.state.renderSection === "SEARCH") {
          return <ProjectFilesSearch onCancel={this.toggleSection} onExit={this.props.hideModal} />;
        } else {
          return null;
        }
      }
    }
  )
);
